import { useEffect, useState } from 'react';
import EpdService from 'services/EpdService';
import { DictionaryValue } from 'types/types';
import { ConformityStandardsPcr, getConformityStandardOptions } from 'util/conformityStandards';

const useConformityStandards = (pcr?: ConformityStandardsPcr) => {
  const [conformityStandards, setConformityStandards] = useState<DictionaryValue[]>([]);

  useEffect(() => {
    const fetchConformityStandards = async () => {
      try {
        const result = await EpdService.getConformityStandards();
        setConformityStandards(result);
      } catch (error) {
        console.error('Failed to fetch conformity standards:', error);
      }
    };

    fetchConformityStandards();
  }, []);

  return getConformityStandardOptions(conformityStandards, pcr);
};

export default useConformityStandards;
